import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'

// vant 原生语言包（已探测确认 vant 2.12.27 自带）
import vantZhCN from 'vant/lib/locale/lang/zh-CN'
import vantZhTW from 'vant/lib/locale/lang/zh-TW'
import vantEnUS from 'vant/lib/locale/lang/en-US'
import vantJaJP from 'vant/lib/locale/lang/ja-JP'
import vantThTH from 'vant/lib/locale/lang/th-TH'
import vantDeDE from 'vant/lib/locale/lang/de-DE'
import vantEsES from 'vant/lib/locale/lang/es-ES'
import vantFrFR from 'vant/lib/locale/lang/fr-FR'
// vant 缺失语种的自补包
import vantKoKR from './vant/ko-KR'
import vantViVN from './vant/vi-VN'
import vantRuRU from './vant/ru-RU'

// 业务语言包
import langZhCN from './zh-CN'
import langZhTW from './zh-TW'
import langEnUS from './en-US'
import langJaJP from './ja-JP'
import langKoKR from './ko-KR'
import langViVN from './vi-VN'
import langThTH from './th-TH'
import langDeDE from './de-DE'
import langFrFR from './fr-FR'
import langRuRU from './ru-RU'
import langEsES from './es-ES'

Vue.use(VueI18n)

export const LANGS = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en-US', label: 'English' },
  { code: 'ja-JP', label: '日本語' },
  { code: 'ko-KR', label: '한국어' },
  { code: 'vi-VN', label: 'Tiếng Việt' },
  { code: 'th-TH', label: 'ไทย' },
  { code: 'de-DE', label: 'Deutsch' },
  { code: 'fr-FR', label: 'Français' },
  { code: 'ru-RU', label: 'Русский' },
  { code: 'es-ES', label: 'Español' },
]

const messages = {
  'zh-CN': langZhCN,
  'zh-TW': langZhTW,
  'en-US': langEnUS,
  'ja-JP': langJaJP,
  'ko-KR': langKoKR,
  'vi-VN': langViVN,
  'th-TH': langThTH,
  'de-DE': langDeDE,
  'fr-FR': langFrFR,
  'ru-RU': langRuRU,
  'es-ES': langEsES,
}

const vantPacks = {
  'zh-CN': vantZhCN,
  'zh-TW': vantZhTW,
  'en-US': vantEnUS,
  'ja-JP': vantJaJP,
  'ko-KR': vantKoKR,
  'vi-VN': vantViVN,
  'th-TH': vantThTH,
  'de-DE': vantDeDE,
  'fr-FR': vantFrFR,
  'ru-RU': vantRuRU,
  'es-ES': vantEsES,
}

function detectLang() {
  const stored = localStorage.getItem('lang')
  const hit = LANGS.filter(function (l) { return l.code === stored })
  if (hit.length) return hit[0].code
  const nav = (navigator.language || 'en-US').toLowerCase()
  const exact = LANGS.filter(function (l) { return l.code.toLowerCase() === nav })
  if (exact.length) return exact[0].code
  const prefix = LANGS.filter(function (l) { return l.code.toLowerCase().indexOf(nav.split('-')[0]) === 0 })
  if (prefix.length) return prefix[0].code
  return 'en-US'
}

function applyVantLocale(code) {
  Locale.use(code, vantPacks[code])
}

export function switchLang(code) {
  i18n.locale = code
  localStorage.setItem('lang', code)
  applyVantLocale(code)
  return code
}

export const i18n = new VueI18n({
  locale: detectLang(),
  fallbackLocale: 'en-US',
  messages,
})

if (!localStorage.getItem('lang')) localStorage.setItem('lang', i18n.locale)

applyVantLocale(i18n.locale)
